import { render, staticRenderFns } from "./DialogImportMinusPoint.vue?vue&type=template&id=354b7fba"
import script from "./DialogImportMinusPoint.vue?vue&type=script&lang=js"
export * from "./DialogImportMinusPoint.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports